function AboutPage() {
  return <>About Page</>;
}

export default AboutPage;